import { render, staticRenderFns } from "./parent-list.vue?vue&type=template&id=24424304&scoped=true&"
import script from "./parent-list.vue?vue&type=script&lang=js&"
export * from "./parent-list.vue?vue&type=script&lang=js&"
import style0 from "./parent-list.vue?vue&type=style&index=0&id=24424304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24424304",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24424304')) {
      api.createRecord('24424304', component.options)
    } else {
      api.reload('24424304', component.options)
    }
    module.hot.accept("./parent-list.vue?vue&type=template&id=24424304&scoped=true&", function () {
      api.rerender('24424304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coachmanage/teammanage/parent-list.vue"
export default component.exports